export const dataAttr = (guard?: boolean): string | undefined => {
  return guard ? `` : undefined;
};

export const ariaAttr = (guard?: boolean): 'true' | undefined => {
  return guard ? `true` : undefined;
};
